// A real app screenshot (see src/appScreens.js) inside a drawn phone bezel.

// `decorative` hides a repeat of a screen shown elsewhere on the page from assistive tech and
// image search, so each capture is described once.
const PhoneShot = ({ screen, className = '', eager = false, decorative = false }) => (
    <div className={`phone-shot ${className}`} aria-hidden={decorative || undefined}>
        <span className="phone-shot-notch" aria-hidden="true" />
        <img
            src={screen.src}
            alt={decorative ? '' : screen.alt}
            width="576"
            height="1130"
            loading={eager ? 'eager' : 'lazy'}
            decoding="async"
        />
    </div>
);

export default PhoneShot;
